import { IconCloudUpload } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './DocumentUploadHint.module.scss';
import { Props } from './DocumentUploadHint.types';

const DocumentUploadHint = ({ isDragging = false }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.container} ${isDragging ? styles.dragging : ''}`}>
      <IconCloudUpload size={56} className={styles.icon} stroke={1.5} />
      <p className={styles.primary}>
        {isDragging
          ? t('documents.uploadHint.drop', 'Déposez vos fichiers ici')
          : t('documents.uploadHint.idle', 'Glissez-déposez vos fichiers ici')}
      </p>
      <p className={styles.secondary}>
        {isDragging
          ? t('documents.uploadHint.dropSubtitle', 'Ils seront ajoutés dans ce dossier')
          : t(
              'documents.uploadHint.idleSubtitle',
              'ou cliquez sur « Ajouter un document » en haut à droite'
            )}
      </p>
    </div>
  );
};

export default DocumentUploadHint;
